import { render } from "./CalculatorInfoBox.vue?vue&type=template&id=5150e631"
import script from "./CalculatorInfoBox.vue?vue&type=script&lang=js"
export * from "./CalculatorInfoBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__